import { AppGlobals } from '@app/app.global';
import { AuthService, SharedService } from '@app/core';
import _ from 'lodash';
export class SideBarSection {
    allSideBarSections = _.cloneDeep(this.appGlobals.sidebarSections);
    constructor(
        private readonly authService: AuthService,
        private readonly appGlobals: AppGlobals,
        private readonly sharedService: SharedService
    ) { }
    isLeadAdminModuleAccess = false;
    canAdminViewReportFlag = false;
    canAdminUploadFlag = false;
    userRoles: any = {};
    featureToggles: any = {};
    topSections = (roleAndIsPaidObject: any, pushToAndBeneficiaryToggles: any, isLeadAdminModuleAccess: boolean, canAdminViewReport: boolean, canAdminUpload: boolean) => {

        this.userRoles = {
            isAdmin: roleAndIsPaidObject.isAdmin, isLeadAdmin: roleAndIsPaidObject.isLeadAdmin,
            isOwner: roleAndIsPaidObject.isOwner, isPaidUser: roleAndIsPaidObject.isPaidUser,
            isManager: roleAndIsPaidObject.isManager
        };

        this.featureToggles = {
            showPushToPetpooja: pushToAndBeneficiaryToggles.showPushToPetpooja, showPushToRetailPos: pushToAndBeneficiaryToggles.showPushToRetailPos,
            showPushToTally: pushToAndBeneficiaryToggles.showPushToTally, showBeneficiary: pushToAndBeneficiaryToggles.showBeneficiary
        };
        this.isLeadAdminModuleAccess = isLeadAdminModuleAccess;
        this.canAdminViewReportFlag = canAdminViewReport;
        this.canAdminUploadFlag = canAdminUpload;

        const sections = _.cloneDeep(this.allSideBarSections);

        const sectionsToReturn = sections.map((section: any) => ({
            ...section,
            menus: section.menus
                .filter((menu: any) => this.hasAccess(this.userRoles, menu.roles)
                    && this.hasPaidAccess(this.userRoles, menu)
                    && this.hasFeatureAccess(this.featureToggles, menu)
                    && this.hasLeadAdminModuleAccess(this.isLeadAdminModuleAccess, menu)
                    && this.canSecondaryOwnerAccess(menu)
                    && this.hasEnablePurchaseAccess(menu))
                .map(menu => ({
                    ...menu,
                    subMenus: menu.subMenus?.filter(
                        sub => this.hasAccess(this.userRoles, sub.roles)
                            && this.hasPaidAccess(this.userRoles, sub)
                            && this.hasFeatureAccess(this.featureToggles, sub)
                            && this.hasLeadAdminModuleAccess(this.isLeadAdminModuleAccess, menu)
                            && this.canSecondaryOwnerAccess(menu)
                            && this.hasHyperpureEnabledAccess(sub)
                    ) || []
                }))
                .filter(menu => menu.path || menu.subMenus.length > 0)
        })).filter(section => section.menus.length > 0);
        return sectionsToReturn;
    }

    // role check
    hasAccess = (userRoles: any, roles?: string[]) => {
        if (!roles) return true;
        return (
            (roles.includes('admin') && userRoles.isAdmin) ||
            (roles.includes('leadAdmin') && userRoles.isLeadAdmin) ||
            (roles.includes('owner') && userRoles.isOwner) ||
            (roles.includes('manager') && userRoles.isManager)
        );
    };

    hasPaidAccess = (userRoles: any, menu: any) => {
        const hasAccess = !menu.requiresPaid || userRoles.isPaidUser;
        return hasAccess;
    };

    hasFeatureAccess = (featureToggles: any, menu: any) => {
        if (!menu.featureFlag) return true;
        return featureToggles[menu.featureFlag];
    };

    hasLeadAdminModuleAccess = (isLeadAdminModuleAccessParameter, menu: any) => {
        let isLeadAdminModuleAccessLocalFlag = false;
        if (menu.roles?.includes("owner")) {
            isLeadAdminModuleAccessLocalFlag = true;
        } else if ((menu.requiresLeadAdminModuleAccess && menu.roles.includes("leadAdmin") && isLeadAdminModuleAccessParameter)) {
            isLeadAdminModuleAccessLocalFlag = true;
        } else if (!menu.requiresLeadAdminModuleAccess) {
            isLeadAdminModuleAccessLocalFlag = true;
        }
        return isLeadAdminModuleAccessLocalFlag;
    }

    canSecondaryOwnerAccess = (menu: any) => {
        let hasAccess = false;

        if (menu.requiresSecondaryOwnerAccess && this.authService.secondaryOwnerCanAccess(menu.path)) {
            hasAccess = true;
        } else if (!menu.requiresSecondaryOwnerAccess) {
            hasAccess = true;
        }
        return hasAccess;
    }

    canAdminViewReport = (menu: any) => {
        let hasAccess = true;

        if (menu.requiresAdminViewAccess && this.authService.user?.isAdmin) {
            if (this.canAdminViewReportFlag) {
                hasAccess = true;
            } else {
                hasAccess = false
            }
        }
        return hasAccess;
    }

    canAdminUpload = (menu: any) => {
        let hasAccess = true;

        if (menu.requiresAdminUploadAccess && this.authService.user?.isAdmin) {
            if (this.canAdminUploadFlag) {
                hasAccess = true;
            } else {
                hasAccess = false
            }
        }
        return hasAccess;
    }

    hasSecondaryOwnerAccess = (menu) => {
        let hasAccess = true;

        if (menu.isSecondaryOwnerRestricted && this.authService.user?.isSecondaryOwner) {
            hasAccess = false;
        }
        return hasAccess;
    }

    hasUserManagementAccess = (menu: any) => {
        let hasAccess = true;
        if (menu.requiresUserManagementAccess && this.authService.user.isSecondaryOwner &&
            this.authService.user.secondaryOwnerRole == 'Employee') {
            hasAccess = false;
        }
        return hasAccess;
    }
    hasDemoAccess = (menu) => {
        let hasAccess = true;

        if (menu.requiresNoDemo && this.authService.user.isDemo) {
            hasAccess = false;
        }
        return hasAccess;
    }

    hasEnablePurchaseAccess = (menu) => {
        let hasAccess = true;

        if (menu.requiresEnablePurchase && !this.authService.user?.enablePurchase) {
            hasAccess = false;
        }
        return hasAccess;
    }

    hasHyperpureEnabledAccess = (menu) => {
        let hasAccess = true;

        if (menu.requiresHyperpureEnabled) {
            // Check both JWT token value and current observable value
            const isHyperpureEnabledInToken = this.authService.user?.isHyperpureEnabled;
            const isHyperpureEnabledDynamic = this.sharedService.hyperpureEnabled.getValue();

            if (!isHyperpureEnabledInToken && !isHyperpureEnabledDynamic) {
                hasAccess = false;
            }
        }
        return hasAccess;
    }

    bottomSections = (roleAndIsPaidObject: any, pushToAndBeneficiaryToggles?: any) => {

        this.userRoles = {
            isAdmin: roleAndIsPaidObject.isAdmin, isLeadAdmin: roleAndIsPaidObject.isLeadAdmin,
            isOwner: roleAndIsPaidObject.isOwner, isPaidUser: roleAndIsPaidObject.isPaidUser
        };

        this.featureToggles = {
            showPushToPetpooja: pushToAndBeneficiaryToggles?.showPushToPetpooja || false,
            showPushToRetailPos: pushToAndBeneficiaryToggles?.showPushToRetailPos || false,
            showPushToTally: pushToAndBeneficiaryToggles?.showPushToTally || false,
            showBeneficiary: pushToAndBeneficiaryToggles?.showBeneficiary || false
        };

        const sections = this.appGlobals.innerSidebarSections;

        const sectionsToReturn = sections.map((section: any) => ({
            ...section,
            menus: section.menus
                .filter((menu: any) => this.hasAccess(this.userRoles, menu.roles)
                    && this.hasFeatureAccess(this.featureToggles, menu)
                    && this.hasPaidAccess(this.userRoles, menu))
                .map(menu => ({
                    ...menu,
                    subMenus: menu.subMenus?.filter(
                        sub => this.hasAccess(this.userRoles, sub.roles) && this.hasSecondaryOwnerAccess(sub) && this.canSecondaryOwnerAccess(sub) &&
                            this.hasUserManagementAccess(sub) && this.hasDemoAccess(sub) && this.hasPaidAccess(this.userRoles, sub) &&
                            this.hasFeatureAccess(this.featureToggles, sub)
                    ) || []
                }))
                .filter(menu => menu.path || menu.subMenus.length > 0)
        })).filter(section => section.menus.length > 0);
        return sectionsToReturn;
    };
}
